<template>
  <div class="edi-operator-connection-select">
    <VSelect
      ref="company-edi-operator"
      v-model="localEdiOperators"
      label="Оператор ЭДО"
      layout="vertical"
      placeholder="Выберите оператора"
      required
      :options="ediOperators"
      :clearable="false"
      :disabled="disabled"
      :multiple="true"
      @input="onInput"
    />

    <div class="external-ids" v-show="localEdiOperatorConnections.length > 0">
      <div class="title">Внешние идентификаторы юр. лиц в системах</div>
      <div class="input-list">
        <VInput
          v-for="ediOperatorConnection in localEdiOperatorConnections"
          :key="ediOperatorConnection.ediOperator.id"
          v-model="ediOperatorConnection.externalId"
          :min-length="1"
          :max-length="50"
          :label="ediOperatorConnection.ediOperator.name"
          :disabled="disabled"
          :required="true"
          placeholder="Введите внешний идентификатор"
          @input="updateModelValue"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import EdiOperator from "@/domains/EdiOperators/EdiOperator";
  import EdiOperatorConnection from "@/domains/EdiOperators/EdiOperatorConnection";
  import Core from "@/core/Core";

  export default {
    name: "EdiOperatorConnectionSelect",

    props: {
      modelValue: {
        type: Array as PropType<EdiOperatorConnection[]>,
        default: []
      },
      ediOperators: {
        type: Array as PropType<EdiOperator[]>
      },
      disabled: {
        type: [Boolean]
      }
    },

    data() {
      return {
        localEdiOperators: this.modelValue.map((ediConnection) => ediConnection.ediOperator),
        localEdiOperatorConnections: Core.utils.cloneDeep(this.modelValue),

        localCheckbox1: false,
        localCheckbox2: false,
        localCheckbox3: false,
      }
    },

    methods: {
      onInput() {
        // Создаем мапу с существующими ediOperatorConnection, чтобы после, у существующих не сбрасывать введенный externalId
        const existingConnectionsMap = new Map<number, EdiOperatorConnection>();
        for (const ediConnection of this.localEdiOperatorConnections) {
          existingConnectionsMap.set(ediConnection.ediOperator.id, ediConnection as EdiOperatorConnection);
        }

        this.localEdiOperatorConnections = this.localEdiOperators.map((ediOperator) => {
          const existingConnection = existingConnectionsMap.get(ediOperator.id);
          return existingConnection || new EdiOperatorConnection(ediOperator as EdiOperator, '');
        });

        this.updateModelValue();
      },

      updateModelValue() {
        this.$emit('update:modelValue', this.localEdiOperatorConnections);
      },
    }
  }
</script>

<style src="./EdiOperatorConnectionSelect.scss" lang="scss" />
